import React from "react";
import useCustomQuery from "../../Hooks/useCustomQuery";
import { useParams } from "react-router-dom";

import Loading from "../../components/Loader/Loading";
import EventOne from "../../components/Common/EventLanding/EventOne";
import CustomFooter from "../../Layout/HorizontalLayout/CustomFooter";

const Index = () => {
  document.title = "Kago Events";
  const obj = JSON.parse(localStorage.getItem("authEventKagoUser"));
  const token = obj?.data?.token;
  const params = useParams();

  const eventID = params?.eventID;

  const {
    data: getMyEventDetail,
    error: errorGetMyEventDetail,
    isLoading: isLoadingGetMyEventDetail,
  } = useCustomQuery(
    ["myEventDetail", eventID],
    `${process.env.REACT_APP_API}events/${eventID}`,
    token
  );

  if (isLoadingGetMyEventDetail) {
    return <Loading title="Loading event..." size={160} fullScreen />;
  }

  const eventType = getMyEventDetail?.data?.eventType;

  return (
    <React.Fragment>
      <div
        style={{
          width: "100%",
          height: "100vh",
          position: "relative",
        }}
      >
        <div
          className="w-100"
          style={{ position: "relative", height: "100vh" }}
        >
          <EventOne
            eventDetails={getMyEventDetail?.data}
            token={token}
            eventID={eventID}
          />
        </div>
        <div className="w-100">
          <CustomFooter />
        </div>
      </div>
    </React.Fragment>
  );
};

export default Index;
